<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9.16634" cy="9.16683" r="5.83333" stroke="#0071FA" stroke-width="2"/>
        <path d="M16.667 16.6665L14.167 14.1665" stroke="#0071FA" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>
<script setup lang="ts">
</script>